import { render, staticRenderFns } from "./UniversityBadges.vue?vue&type=template&id=52f3e66b&scoped=true&"
import script from "./UniversityBadges.vue?vue&type=script&lang=js&"
export * from "./UniversityBadges.vue?vue&type=script&lang=js&"
import style0 from "./UniversityBadges.vue?vue&type=style&index=0&id=52f3e66b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f3e66b",
  null
  
)

export default component.exports